import lscache from 'lscache';
import CapitalClient from '@/api/CapitalClient';

const actions = {
  preloadOpenInvoices(_, dealerId) {
    const cacheKey = `open-invoices/dealer/${dealerId}`;
    const cachedOpenInvoices = lscache.get(cacheKey);

    // Exit early if the cache is not supported or the data is already cached
    if (!lscache.supported() || cachedOpenInvoices) {
      return;
    }
    const capitalClient = new CapitalClient();

    capitalClient.fetchOpenInvoices(dealerId)
      .then((response) => {
        lscache.set(cacheKey, { ...response, set_time: new Date() }, 15);
      });
  },
};

export default {
  namespaced: true,
  actions,
};
